import { ReactNode } from 'react'

import { Icon } from '../Icon'

type DismissibleBannerProps = {
  /** 左端の丸枠に表示するアイコン。 */
  icon: ReactNode
  title: string
  description: string
  /** 閉じるボタンの aria-label。 */
  dismissLabel: string
  onDismiss: () => void
  /** 説明文の下に差し込む固有コンテンツ（手順リストやアクションボタン等）。 */
  children?: ReactNode
}

/**
 * 画面上部に表示する案内バナーの共通枠。丸アイコン＋タイトル＋説明＋閉じるボタンの
 * カード構造を提供し、バナー固有のコンテンツは children で差し込む。
 */
export function DismissibleBanner({
  icon,
  title,
  description,
  dismissLabel,
  onDismiss,
  children,
}: DismissibleBannerProps) {
  return (
    <div
      className="mb-5 flex items-start gap-3 rounded-2xl border border-accent/40 bg-accent-soft px-4 py-3 text-sm text-ink shadow-sm"
      role="region"
      aria-label={title}
    >
      <span className="mt-0.5 grid h-9 w-9 shrink-0 place-items-center rounded-full bg-accent text-white">
        {icon}
      </span>

      <div className="min-w-0 flex-1">
        <strong className="block font-semibold text-ink">{title}</strong>
        <p className="mt-1 text-muted">{description}</p>
        {children}
      </div>

      {/* lg 未満（タッチ端末）は押せる範囲を約 46px に広げ、負のマージンで見た目の位置と
          レイアウトは 26px のときと同じに保つ */}
      <button
        type="button"
        onClick={onDismiss}
        aria-label={dismissLabel}
        className="shrink-0 rounded-lg p-1 text-muted transition-colors hover:bg-white hover:text-ink max-lg:-m-2.5 max-lg:p-3.5"
      >
        <Icon icon="close" width={18} height={18} />
      </button>
    </div>
  )
}
